import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import { Camera } from "@mui/icons-material";
import { Notifications } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import { useNavigate } from "react-router-dom";
import i18n from "../../translationUtils/i18n";
import { useAuth } from "../../utils/AuthProvider";
import { useWalkthrough } from "../../utils/WalkthroughProvider";
import {
  canAccessManagement,
  canViewDistributors,
} from "../../utils/permissions";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";

export default function NavMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { cookies } = useAuth();
  const { registerMenuOpener } = useWalkthrough();

  useEffect(() => {
    const unregister = registerMenuOpener(setOpen);
    return unregister;
  }, [registerMenuOpener]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleRedirect = (link) => {
    navigate(`/${link}`);
    setOpen(false);
  };

  return (
    <div>
      <Button style={{ color: "white" }} onClick={toggleDrawer(true)}>
        <MenuIcon />
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          <List>
            {[i18n.t("healthdashboard")].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton onClick={() => handleRedirect("")}>
                  <ListItemIcon>
                    <MonitorHeartIcon />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}

            {[i18n.t("notifications")].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton onClick={() => handleRedirect("notifications")}>
                  <ListItemIcon>
                    <Notifications />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}

            {[i18n.t("notificationsettings")].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton onClick={() => handleRedirect("settings")}>
                  <ListItemIcon>
                    <EditNotificationsIcon />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}

            {canAccessManagement(cookies.role) &&
              [i18n.t("sitemanagement")].map((text, index) => (
                <ListItem key={text} disablePadding>
                  <ListItemButton onClick={() => handleRedirect("sites")}>
                    <ListItemIcon>
                      <ManageAccountsIcon />
                    </ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              ))}

            {canViewDistributors(cookies.role) &&
              [i18n.t("distributors")].map((text, index) => (
                <ListItem key={text} disablePadding>
                  <ListItemButton onClick={() => handleRedirect("distributors")}>
                    <ListItemIcon>
                      <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              ))}

            {[i18n.t("account")].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton onClick={() => handleRedirect("account")}>
                  <ListItemIcon>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}

            {[i18n.t("privacypolicy")].map((text, index) => (
              <ListItem key={text} disablePadding>
                <ListItemButton
                  onClick={() => handleRedirect("privacy-policy")}
                >
                  <ListItemIcon>
                    <PrivacyTipIcon />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Button onClick={() => handleRedirect('settings')} variant='contained' style={{ marginTop: '40px' }}>Settings</Button>
        </div> */}
      </Drawer>
    </div>
  );
}